import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 12 12'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={0.96}
      d='M9.2 3.4 4.8 7.8l-2-2'
    />
  </svg>
)
export default SvgComponent
